module.exports = __webpack_public_path__ + "static/media/one.21230f32.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/onBoarding/one.png
// module id = 1581
// module chunks = 0